import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import apiMethods from '../../../apis';
import useGet from '../../../services/hooks/http/useGet';
import utils from '../../../services/utils';
import { accountSubTypeLabelObject, sourceIconMeloAccountsObject, sourceIconMoviiAccountsObject, sourceIconAccountsObjectAndPSE } from '../../../store/catalogs/banks';
import Context from '../../../store/context';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import Tags from '../../Tags/Tags';
import Tooltip from '../../Tooltip/Tooltip';

import classes from './SupplierAndInvoiceCard.module.scss';
import { statusAccountTransaction, typesStatusAccount } from '../../../store/constants/statusDruoAccounts';

const SupplierAndInvoiceCard = ({
  supplierName,
  supplierId,
  payoutId,
  bankId,
  bankAccountType,
  bankLast4Digits,
  purchasesItems,
  totalValue,
  view,
  owner,
  identification,
  meloStatus,
  statusDescription,
  showDetails,
  showInvoiceDetail,

  supplierMoviiBankId,
  methodForPay
}) => {
  const {
    modal: { showError }
  } = useContext(Context);

  const { businessId } = useSelector(state => state.userData);
  const iconBank = 
    methodForPay === 'PSEPay' 
      ? sourceIconMoviiAccountsObject[supplierMoviiBankId] 
      : bankId === 'cybersource' 
        ? sourceIconAccountsObjectAndPSE[bankId]
        : sourceIconMeloAccountsObject[bankId];

  const {
    isError: getError,
    isSuccess: getSuccess,
    data,
    errorMessage
  } = useGet(apiMethods.getPurchase, [purchasesItems[0].purchaseId], purchasesItems.length === 1 && bankId !== 'cybersource');

  const [voucherState, setVoucherState] = useState({ fetch: false, supplierId: '', payoutId: '' });

  const {
    isError: getVoucherError,
    isSuccess: getVoucherSuccess,
    data: getVoucherData,
    errorMessage: errorMessageVoucher
  } = useGet(apiMethods.getSupplierPayoutVoucher, [businessId, voucherState.payoutId, voucherState.supplierId], voucherState.fetch && bankId !== 'cybersource');

  useEffect(() => {
    if (getSuccess) {
    } else if (getError) {
      showError({ title: 'Traer cuenta de cobro', description: errorMessage });
    }
  }, [getError, getSuccess, showError, errorMessage]);

  const payoutVoucer = () => {
    setVoucherState({ fetch: true, supplierId, payoutId });
  };

  useEffect(() => {
    if (getVoucherSuccess) {
      setVoucherState({ fetch: false, supplierId: '', payoutId: '' });
      utils.downloadFileByUrl(getVoucherData);
    } else if (getVoucherError) {
      setVoucherState({ fetch: false, supplierId: '', payoutId: '' });
      showError({ title: 'Descargar detalle', description: errorMessageVoucher });
    }
  }, [errorMessageVoucher, getVoucherData, getVoucherError, getVoucherSuccess, showError]);

  const bankSubType = accountSubTypeLabelObject[bankAccountType] || (bankId === 'cybersource' ? 'Tarjeta de Crédito' : 'Cuenta');

  return (
    <div className={classes.card}>
      <div className={classes.between}>
        <span className='semibold-18'>{supplierName}</span>
        <div className={classes.status}>
          <Tags text={statusAccountTransaction[meloStatus].label} type={statusAccountTransaction[meloStatus].color} />
          <Tooltip
            classNameChildren={classes.tooltip}
            content={`${statusAccountTransaction[meloStatus].tooltip} ${
              meloStatus === typesStatusAccount.ERROR ? statusDescription || '' : ''
            }`}>
            <CircleExclamation />
          </Tooltip>
        </div>
      </div>
      <div className={classes.between}>
        <FieldBold title='CUENTA DESTINO'>
          <div>{iconBank}</div>
          <span className='medium-16'>
            {bankSubType} ****{bankLast4Digits}
          </span>
        </FieldBold>
        <Button onClick={() => showDetails(iconBank, bankSubType, bankLast4Digits, owner, identification)} custom='quaternary'>
          Ver detalles
        </Button>
      </div>
      <div className={classes.between}>
        <FieldBold title='CANTIDAD DE CUENTAS' value={`${purchasesItems.length} cuentas`} />
        <Button onClick={() => showInvoiceDetail(purchasesItems, supplierName, totalValue, data, meloStatus)} custom='quaternary'>
          Ver detalles
        </Button>
      </div>
      <FieldBold title='TOTAL A PAGAR' value={utils.moneyFormat(totalValue)} />
      {view === 'history' && bankId !== 'cybersource' && (
        <Button
          className={classes.download}
          onClick={payoutVoucer}
          Icon={ArrowDownLine}
          enabled={meloStatus === 'SUCCESS'}
          custom='quaternary'>
          Descargar detalle
        </Button>
      )}
    </div>
  );
};

export default SupplierAndInvoiceCard;
